import React, { useState, useEffect } from "react";
import Web3 from "web3";
import './styles.css';
// Ensure web3 is only initialized once the window is ready
let web3;
if (typeof window !== "undefined") {
    web3 = new Web3(new Web3.providers.HttpProvider("https://182d-103-210-49-131.ngrok-free.app"));
    window.web3 = web3; // Now available globally
}

const contractABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "balances",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_user",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "_amount",
        "type": "uint256"
      }
    ],
    "name": "decrementBalance",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_user",
        "type": "address"
      }
    ],
    "name": "getBalance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_user",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "_amount",
        "type": "uint256"
      }
    ],
    "name": "incrementBalance",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];
const contractAddress = "0x0165878A594ca255338adfa4d48449f69242Eb8F"; // Your deployed contract
const contract = new web3.eth.Contract(contractABI, contractAddress);

const ownerAddress = "0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266";
const privateKey = "0xac0974bec39a17e36ba4a6b4d238ff944bacb478cbed5efcae784d7bf4f2ff80";

export default function App() {
    const [userAddress, setUserAddress] = useState("");
    const [amount, setAmount] = useState(""); // for the custom amount
    const [balance, setBalance] = useState(null);
    const [loading, setLoading] = useState(false);
    const [generatedAddress, setGeneratedAddress] = useState("");
    const [generatedPrivateKey, setGeneratedPrivateKey] = useState("");

    async function sendTransaction(methodName, amount) {
        setLoading(true);
        try {
            console.log(`Sending transaction: ${methodName} with amount ${amount} for ${userAddress}`);
            const tx = {
                from: ownerAddress,
                to: contractAddress,
                gas: 2000000,
                data: contract.methods[methodName](userAddress, amount).encodeABI()
            };
            const signedTx = await web3.eth.accounts.signTransaction(tx, privateKey);
            const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);
            console.log("Transaction successful:", receipt);
            alert("Transaction successful!");
        } catch (error) {
            console.error("Transaction failed:", error);
            alert("Transaction failed!");
        }
        setLoading(false);
    }

    async function getUserBalance() {
        try {
            console.log("Fetching balance for:", userAddress);
            const userBalance = await contract.methods.getBalance(userAddress).call();
            console.log("Fetched balance:", userBalance.toString());
            setBalance(userBalance.toString());
        } catch (error) {
            console.error("Error fetching balance:", error);
            alert("Error fetching balance!");
        }
    }

    const generateNewAddress = () => {
        const account = web3.eth.accounts.create();
        setGeneratedAddress(account.address);
        setGeneratedPrivateKey(account.privateKey);
    };

    return (
        <div className="app-container">
            <h1>Psuedo Currency Management</h1>

            <input
                type="text"
                className="input-field"
                placeholder="Enter User Address"
                value={userAddress}
                onChange={(e) => setUserAddress(e.target.value)}
            />

            <input
                type="number"
                className="input-field"
                placeholder="Enter Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
            />

            <button 
                onClick={() => sendTransaction("incrementBalance", amount)} 
                className="button bg-green" 
                disabled={loading}
            >
                Increment Balance
            </button>
            <button 
                onClick={() => sendTransaction("decrementBalance", amount)} 
                className="button bg-red" 
                disabled={loading}
            >
                Decrement Balance
            </button>
            <button onClick={getUserBalance} className="button bg-blue" disabled={loading}>
                Check Balance
            </button>

            {balance !== null && (
                <div className="balance-display">
                    Balance: {balance}
                </div>
            )}

            {loading && <div className="loading-text">Processing...</div>}

            <button onClick={generateNewAddress} className="button bg-purple" disabled={loading}>
                Generate New Address
            </button>

            {generatedAddress && (
                <div className="generated-info">
                    <p><strong>New Address:</strong> {generatedAddress}</p>
                    <p><strong>Private Key:</strong> {generatedPrivateKey}</p>
                </div>
            )}
        </div>
    );
}
